import React, { Component } from 'react'
import Collapse from 'src/Components/Collapse/Collapse'
import './styles.scss';

export default class FAQ extends Component {
  constructor(props) {
    super(props);
    let  qaList  = this.props.support;

    this.state = {
      feedbackModalVisible: false,
      qaList: qaList && qaList.length > 0 ? qaList.slice(0, 5) : [],
      showMoreBtn: true
    }

  }

  componentDidUpdate(prevProps) {
    let  qaList = this.props.support;
    if (prevProps.support !== this.props.support) {
      if (qaList && qaList.length > 0) {
        this.setState({
          qaList: qaList.slice(0, 5),
          showMoreBtn: true
        })
      }
    }
  }
  showMoreQa = () => {
    let  QAList  = this.props.support;
    this.setState({
      qaList: QAList,
      showMoreBtn: false
    })
  }

  renderAnswers = (obj) => {
    return <span dangerouslySetInnerHTML={{ __html: obj.data.htmlData }}></span>     
  }
  
  renderQA = qaList => {

    return (
      <>
        {qaList && qaList.length > 0 && qaList.map((ob, i) => {        
          return (
            <div className="faq-collapse-wrapper" key={ob.id}>
              <Collapse title={ob.data.label} open={ob.data.open}>
                <div className="answer-wrapper" key={ob.data.label}>
                  {this.renderAnswers(ob)}
                </div>
              </Collapse>
            </div>
          )
        })}
      </>
    )
  }

  render() {
    const { faqHeading, helpAskText, showAllText } = this.props.faq;
    let { qaList, showMoreBtn } = this.state;
  
    return (      
      <div className="faq-section">
        <h3 className="faq-heading">{faqHeading}</h3>
        <div className="faq-help-text">{helpAskText}</div>
        {this.renderQA(qaList)}
        {showMoreBtn && <div className="show-all-text" onClick={this.showMoreQa}>{showAllText}</div>}
      </div>
         
    )
  }
}
